var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10675_2159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2 17.18C20.4444 16.16 21.3333 14.8 21.3333 13.1C21.3333 10.21 19.0222 8 16 8C12.9778 8 10.6667 10.21 10.6667 13.1C10.6667 14.8 11.5556 16.16 12.8 17.18C9.95556 18.37 8 21.09 8 24.15C8 24.66 8.35556 25 8.88889 25C9.42222 25 9.77778 24.66 9.77778 24.15C9.77778 20.92 12.6222 18.2 16 18.2C19.3778 18.2 22.2222 20.92 22.2222 24.15C22.2222 24.66 22.5778 25 23.1111 25C23.6444 25 24 24.66 24 24.15C24 21.09 22.0444 18.37 19.2 17.18ZM16 16.5C14.0444 16.5 12.4444 14.97 12.4444 13.1C12.4444 11.23 14.0444 9.7 16 9.7C17.9556 9.7 19.5556 11.23 19.5556 13.1C19.5556 14.97 17.9556 16.5 16 16.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10675_2159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.022587a6d2f835e14d7b6fdfd9893a36.svg";
export { ForwardRef as ReactComponent };